module.exports = __webpack_public_path__ + "img/0S6A9364.17ee48c7.jpg";